export default "https://cdn-static.gokick.com/assets/1c04a0e7cb9e690604c984af7e1d0f36647cf8e0/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";